import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";
import EXIF from "exif-js";

import ManagerBase from "./ManagerBase";
import ImageExifData from "../models/ImageExifData";

class ImageContentManager extends ManagerBase {
	constructor () {
		super("imageContentManager");
		this.remoteClassName = "image-content";
	}

	async extractAndAddImageAndExifData (file, currContent) {
		return new Promise(resolve => {
			EXIF.getData(file, () => {
				console.log({exifdata: file.exifdata, file});

				const exifData = new ImageExifData(file.exifdata);
				exifData.rawData = file;
				console.log({exifData});

				const shootDateRaw = exifData.rawData.iptcdata.dateCreated;
				let shootDate = "";
				
				if (shootDateRaw) {
					shootDate = new Date(`${shootDateRaw.slice(0, 4)}-${shootDateRaw.slice(4, 6)}-${shootDateRaw.slice(6, 8)}`);
				}

				const creationDateRaw = exifData.rawData.exifdata.DateTime;
				let creationDate = "";

				if (creationDateRaw && !isNaN(new Date(creationDateRaw))) {
					creationDate = new Date(creationDateRaw).toISOString();
				}
				
				currContent.set({
					authorName: exifData.Artist,
					copyright: exifData.Copyright,
					__creationDate: creationDate,
					__exifCreationDate: exifData.DateTime,
					description: exifData.ImageDescription,
					fileByteSize: file.size,
					fileIntrinsicHeight: exifData.rawData.exifdata.PixelYDimension,
					fileIntrinsicWidth: exifData.rawData.exifdata.PixelXDimension,
					fileType: file.type,
					originalExifData: exifData || {},
					originalFileName: file.name,
					originalImageInfo: {
						authorName: exifData.Artist,
						fileByteSize: file.size,
						height: exifData.rawData.exifdata.PixelYDimension,
						width: exifData.rawData.exifdata.PixelXDimension,
					},
					__shootDate: !shootDate || isNaN(shootDate) ? "" : shootDate.toISOString().slice(0, 10),
					source: imageContentManager.extractSource(file.exifdata.Copyright || file.iptcdata.credit, file.name),
				});

				resolve(currContent);
			});
		});
	}

	extractAndSetImagePermissionsFromSource (item) {
		if (item.extraData.permissionsAutoSet === undefined) {
			item.extraData.permissions = {
				editorial: true,
				marketing: true,
				web: !item.source.toLowerCase().includes("getty"),
			};
			item.extraData.permissionsAutoSet = true;
			return true;
		}

		return false;
	}

	extractSource (copyright, fileName) {
		const destinations = ["Shutterstock", "Getty"];

		for (var i = 0; i < destinations.length; i++) {
			if (copyright && copyright.toLowerCase().includes(destinations[i].toLocaleLowerCase())) {
				return destinations[i];
			}
			else if (fileName && fileName.toLowerCase().includes(destinations[i].toLocaleLowerCase())) {
				return destinations[i];
			}
		}

		return "";
	}
	
	getByOriginalFileName (originalFileName) {
		const rd = NousCore.api.createRequest({ filters: { originalFileName } });
		const requestedAction = "get-by-original-file-name";//NOn è meglio un generico search?

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}
	
	getExifData (item) {
		const rd = NousCore.api.createRequest({ item });
		const requestedAction = "get-exif-data";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}
}

const imageContentManager = new ImageContentManager();

Shark.registerController(imageContentManager);

export default imageContentManager;
